import { render } from "./FeatureBlock.vue?vue&type=template&id=69716c0e&scoped=true"
import script from "./FeatureBlock.vue?vue&type=script&lang=js"
export * from "./FeatureBlock.vue?vue&type=script&lang=js"

import "./FeatureBlock.vue?vue&type=style&index=0&id=69716c0e&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69716c0e"]])

export default __exports__